export const EVENT_TYPE_LABELS: Record<string, string> = {
  NOMENCLATURE_ERROR: 'Ошибка в карточке товара',
  SYSTEM_BUG: 'Баг системы',
  ORDER_SUBMITTED: 'Заказ оформлен',
  ORDER_IN_WORK: 'Заказ в работе',
  ORDER_REPLICATED: 'Заказ принят поставщиком',
  ORDER_CANCELED: 'Заказ отменён',
  ORDER_BROKER_FAILED: 'Ошибка отправки заказа',
  NEW_ORGANISATION: 'Новая организация',
  PARTNERSHIP_EVENT: 'Событие партнёрства',
  NEWS: 'Новости',
}

export const cronOptions = [
  { value: '0 */15 * * * *', label: '15 мин' },
  { value: '0 */30 * * * *', label: '30 мин' },
  { value: '0 0 * * * *', label: '1 час' },
  { value: '0 0 */2 * * *', label: '2 часа' },
  { value: '0 0 */3 * * *', label: '3 часа' },
  { value: '0 0 */6 * * *', label: '6 часов' },
  { value: '0 0 */8 * * *', label: '8 часов' },
  { value: '0 0 */12 * * *', label: '12 часов' },
  { value: '0 0 0 * * *', label: '24 часа' },
] as const

export const legacyCronMap: Record<string, string> = {
  '0 0/15 * * * *': '0 */15 * * * *',
  '0 0/30 * * * *': '0 */30 * * * *',
  '0 0 0/1 * * *': '0 0 * * * *',
  '0 0 0/2 * * *': '0 0 */2 * * *',
  '0 0 0/3 * * *': '0 0 */3 * * *',
  '0 0 0/6 * * *': '0 0 */6 * * *',
  '0 0 0/8 * * *': '0 0 */8 * * *',
  '0 0 0/12 * * *': '0 0 */12 * * *',
  '0 0 0/24 * * *': '0 0 0 * * *',
}

export const TYPE_LABELS: Record<string, string> = {
  NUMERIC: 'Числовой',
  BOOLEAN: 'Булевый',
  REFERENCE: 'Ссылочный',
  STRING: 'Строковый',
  // Слотовый: у товара по одному значению на каждое присоединение
  // («Диаметр присоединения»), записка §6
  SLOTTED_REFERENCE: 'Слотовый (присоединения)',
}
